import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18 5L6.00004 5.00001C5.44775 5.00001 5.00004 5.44772 5.00004 6L5.00002 12H8.12601C8.5823 12 8.98072 12.3089 9.09445 12.7507C9.42754 14.0449 10.6035 15 12 15C13.3965 15 14.5724 14.0449 14.9055 12.7507C15.0193 12.3089 15.4177 12 15.874 12H19V6C19 5.44772 18.5523 5 18 5ZM19 14H16.5836C15.8122 15.7655 14.0512 17 12 17C9.94877 17 8.18782 15.7655 7.41637 14H5.00001L5 18C5 18.5523 5.44771 19 6 19H18C18.5523 19 19 18.5523 19 18V14ZM6.00004 3.00001L18 3C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34314 21 2.99999 19.6569 3 18L3.00004 6C3.00004 4.34315 4.34319 3.00001 6.00004 3.00001Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }